import './App.css';
import HomePage from './component/HomePage';

function App() {
  return (
    // <div className="App">
          <HomePage/>
      // </div>
  );
}

export default App;
